/**
 * The function whose prototype all chaining wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;



/*****************
 ** WEBPACK FOOTER
 ** ./~/recompose/~/lodash/_baseLodash.js
 ** module id = 104
 ** module chunks = 0
 **/